/*
 modalDialog

 Custom Knockout bindingHandler for rendering a modal dialog window.

 Expects the following values to be passed in:
 -- onClosed: a callback function that will be called when the dialog closes.
 -- showDialog: a boolean flag that determines if the dialog should show or hide.
 -- title: the title of the dialog.
 -- width: (optional) the width of the dialog.

 */

import 'bootstrap/js/modal';
import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';

var modalDialog = {};

//Custom dropdown binding handler
ko.bindingHandlers.modalDialog = modalDialog = {
  init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    // This will be called when the binding is first applied to an element
    // Set up any initial state, event handlers, etc. here

    var props = ko.toJS(valueAccessor());

    var $element = $(element);
    var onClosedCallback = props.onClosed;

    //Create the dialog in the DOM
    var dialogHtml = $("#modal-dialog-template").html();
    var headerHtml = $("#modal-dialog-header-template").html();
    $element.wrapInner(dialogHtml);
    $element.find(".modal-content").prepend(headerHtml);

    //Add a callback for the closed event
    $element.find('.modal').on('hidden.bs.modal', function () {

      if (!_.isNullOrUndefined(onClosedCallback)) {
        onClosedCallback.call(null, null);
      }      
    })

  },
  update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    // This will be called once when the binding is first applied to an element,
    // and again whenever any observables/computeds that are accessed change
    // Update the DOM element based on the supplied values here.

    var props = ko.toJS(valueAccessor());

    var $element = $(element);

    var showDialog = _.defaultIfNullOrUndefined(props.showDialog, false);
    var dialogWidth = props.width;

    if (showDialog) {
      $element.find('.modal').modal('show');
      
      //Update the width of the dialog
      if (dialogWidth)
        $element.find('.modal-dialog').width(dialogWidth);

      //Update the title
      var title = _.defaultIfNullOrUndefined(props.title, "New Dialog");
      $element.find('.modal-title').text(title);
    }
    else {
      $element.find('.modal').modal('hide');
    }
  }
};
